import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BottomButtonsPanelComponent } from './bottom-buttons-panel.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [BottomButtonsPanelComponent],
  exports: [BottomButtonsPanelComponent]
})
export class BottomButtonsPanelModule { }
